::ng-deep particle-transmission-form-editor-container{display:flex}
/*# sourceMappingURL=transmission-form-editor-container.component-U3KFSU3H.css.map */
